const vendorsTypes = {
  VENDORS_TABLE_STATE_SET: 'VENDORS/TABLE_STATE_SET',
  VENDORS_TABLE_STATE_RESET: 'VENDORS/TABLE_STATE_RESET',
  VENDORS_SELECTED_ROWS_SET: 'VENDORS/SELECTED_ROWS_SET',
};
export default vendorsTypes;
